import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { BID_REQUEST_STATUS_ENUM, BidRequestStatus } from "interfaces";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { cancelBid } from "services";

export const CancelBidButton = observer(() => {
  const { actionModals, bidCard } = useStores();
  const bidStatus = bidCard.bid.status;

  const cancelBidHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          buttonText="Подтвердить"
          text="Подтвердите отмену заявки"
          successText="Заявка успешно отменена"
          calledQuery={() => cancelBid({ id: bidCard.bid.id })}
          // onSuccess={() => {
          //   setTimeout(() => {
          //     window.updateOnboardingElements?.();
          //   }, 1000);
          // }}
        />
      ),
      {
        ...confirmationModalConfigs,
        width: "450px",
        title: "Отмена заявки",
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <CustomButton type="default" onClick={cancelBidHandler} tooltip="Заявка будет отменена" id={getButtonId(bidStatus)}>
      Отменить заявку
    </CustomButton>
  );
});

const getButtonId = (bidStatus: BidRequestStatus) => {
  switch (bidStatus) {
    case BID_REQUEST_STATUS_ENUM.DRAFT:
    case BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED:
    case BID_REQUEST_STATUS_ENUM.NEW:
      return "cancel-bid-draft-button";
    default:
      return undefined;
  }
};
